import { useIntl } from "react-intl";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { SectionData } from "../../services/PlansService";
import { observer } from "mobx-react-lite";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import styled from "@mui/material/styles/styled";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const SectionChangerBox = styled(Box)(({ theme }) => ({
  borderBottom: `solid 1px ${theme.palette.divider}`
}));

interface SectionChangerProps {
  currentSection: number;
  changeSection: (section: number) => void;
  sectionsData: SectionData[];
}

const SectionChanger: React.FC<SectionChangerProps> = observer(({ currentSection, changeSection, sectionsData }) => {

  const intl = useIntl();

  const numSections = sectionsData.filter((s) => s.type === "section").length;

  return (
    <SectionChangerBox display="flex" alignItems="center" justifyContent="space-between" paddingY={1} paddingX={2}>
      <IconButton onClick={() => changeSection(currentSection - 1)} size="small" disabled={currentSection === 0}>
        <ChevronLeft fontSize="small" />
      </IconButton>
      <Select
        value={currentSection}
        size="small"
        variant="standard"
        onChange={(event) => changeSection(+event.target.value)}
        style={{ fontSize: "0.875rem", fontWeight: 700 }}
      >
        {sectionsData.map((currentSectionData, index) => (
          <MenuItem value={index} key={index}>
            {currentSectionData.type === "section" ? intl.formatMessage({ id: "data.section" }, { num: Math.ceil(index / 2), total: numSections }) :
              currentSectionData.type === "start" ? `${intl.formatMessage({ id: "plans.start" })}${currentSectionData.name ? `: ${currentSectionData.name}` : ""}` :
                currentSectionData.type === "end" ? `${intl.formatMessage({ id: "plans.end" })}${currentSectionData.name ? `: ${currentSectionData.name}` : ""}` :
                  `${intl.formatMessage({ id: "plans.CP" })} ${Math.ceil(index / 2)}${currentSectionData.name ? `: ${currentSectionData.name}` : ""}`}
          </MenuItem>
        ))}
      </Select>
      <IconButton onClick={() => changeSection(currentSection + 1)} size="small" disabled={currentSection === sectionsData.length - 1}>
        <ChevronRight fontSize="small" />
      </IconButton>
    </SectionChangerBox>
  );
});

export default SectionChanger;